/* eslint-disable no-undef */
import constants from '@/core/tests/jest';

const matchMedia = () => {
    return Object.defineProperty(window, 'matchMedia', {
        writable: true,
        value: jest.fn().mockImplementation((query) => ({
            matches: false,
            media: query,
            onchange: null,
            addListener: jest.fn(),
            removeListener: jest.fn(),
            addEventListener: jest.fn(),
            removeEventListener: jest.fn(),
            dispatchEvent: jest.fn(),
        })),
    });
};

const localStore = async() => {
    const storePath = `${constants.buildDirRootPath}/store.js`;
    const store = await import(`${storePath}`);

    return await store.createStore();
};

export default {
    matchMedia,
    localStore,
};
